import React, { FC } from "react";
import { Wrapper, MPUWrapper, ArticlesWrapper } from "./HeroPlus6.styled";
import MPU from "common/Layout/Adverts/MPU";
import Hero from "Components/Hero";
import Item from "Components/Item";
import { ArticleComponent } from "../types";
import { getCropData } from "../getCropData";

type Props = {
  data: ArticleComponent;
};

const HeroPlus6: FC<Props> = ({ data }) => {
  if (!data.articles || data.articles.every((article) => article === null)) {
    return null;
  }
  const [mainArticle, ...articles] = data.articles;

  return (
    <Wrapper className={"hero6-only"}>
      <Hero
        size={6}
        article={mainArticle}
        cropData={getCropData(mainArticle, "threebytwo")}
      />
      <ArticlesWrapper className="articles-wrapper">
        {articles.map((article, index) => (
          <Item
            key={index}
            size={6}
            article={article}
            cropData={getCropData(article, "onebyone")}
          />
        ))}
      </ArticlesWrapper>
    </Wrapper>
  );
};

export default HeroPlus6;
